import { DataRoomFolderBrowseFragmentFragment } from "@/src/graphql/generated";
import { DataRoomFilters } from "..";
import { sortByIndex } from "@/src/utils/sortByIndex";
import { DataRoomListItem } from "../dnd/useDataRoomListSelection";

/** Visible folder then file ids in the same order as the table. */
export function getVisibleDataRoomListItems(
  folder: DataRoomFolderBrowseFragmentFragment,
  filters: DataRoomFilters,
  indexingEnabled: boolean,
): DataRoomListItem[] {
  const folders = folder.folders
    .filter((f) => {
      if (filters.type && filters.type !== "Folder") return false;
      if (filters.createdBy && f.createdBy.id !== filters.createdBy.id) {
        return false;
      }
      if (filters.lastUpdated && f.updatedAt < filters.lastUpdated) {
        return false;
      }
      return true;
    })
    .sort((a, b) => sortByIndex(a, b, indexingEnabled))
    .map((f) => ({ id: f.id, type: "folder" as const }));

  const files = folder.files
    .filter((f) => {
      if (filters.type && filters.type !== f.fileType) return false;
      if (filters.createdBy && f.createdBy.id !== filters.createdBy.id) {
        return false;
      }
      if (filters.lastUpdated && f.updatedAt < filters.lastUpdated) {
        return false;
      }
      return true;
    })
    .sort((a, b) => sortByIndex(a, b, indexingEnabled))
    .map((f) => ({ id: f.id, type: "file" as const }));

  return [...folders, ...files];
}
